import React from "react";
import AdamsSneakerGallery from "./AdamsSneakerGallery";
import GlobalStyles from "./GlobalStyles";

function App() {
  return (
    <>
      <GlobalStyles />
      <AdamsSneakerGallery />
    </>
  );
}

export default App;
